// Sidebar section catalog + completion helper used by LoanSidebar.
import {
  FileText, Users, Sparkles, Home as HomeIcon, User as UserIcon,
  DollarSign, Layers, CheckSquare, Bell, Folder, FileCheck2,
  ClipboardList, Award, BarChart3, Link2,
} from 'lucide-react';
import { hasFees } from './leFees';

export const SIDEBAR_TOP = [
  { key: 'loan_property', label: 'Loan & Property', icon: HomeIcon },
  { key: 'borrower_info', label: 'Borrower Info', icon: UserIcon },
  { key: 'financial_info', label: 'Financial Info', icon: DollarSign },
  { key: 'products_pricing', label: 'Products & Pricing', icon: Layers },
  { key: 'review_fees', label: 'Review Fees', icon: FileText, badge: 'QM' },
  { key: 'dual_aus', label: 'Dual AUS', icon: CheckSquare },
  { key: 'pre_approval', label: 'Pre-Approval', icon: FileCheck2 },
];

export const SIDEBAR_BOTTOM = [
  { key: 'loan_center', label: 'Loan Center', icon: Bell },
  { key: 'client_needs', label: 'Client Needs', icon: ClipboardList },
  { key: 'conditions', label: 'Conditions', icon: CheckSquare },
  { key: 'documents', label: 'Documents', icon: Folder },
  { key: 'disclosure_forms', label: 'Disclosure Forms', icon: FileText },
  { key: 'loan_quotes', label: 'Loan Quotes', icon: DollarSign },
  { key: 'funding_revenue', label: 'Funding / Revenue', icon: Award },
  { key: 'audit_dates', label: 'Audit & Dates', icon: BarChart3 },
  { key: 'urla_full', label: 'URLA (Full 1003)', icon: FileText },
  { key: 'parties_sharing', label: 'Parties & Sharing', icon: Users },
  { key: 'ai_processor', label: 'AI Processor', icon: Sparkles, ai: true },
];

// Shown only on Arive-synced loan files (ticket 134 P1).
export const SIDEBAR_ARIVE = { key: 'arive', label: 'Arive', icon: Link2 };

// Which sections are complete based on loan data (progressive checklist).
// A section with no key here has no completion step and shows its own icon
// (Dual AUS: findings are not stored anywhere yet, so it cannot be "done").
export function computeCompletion(loan) {
  const c = {};
  const b = loan.urla?.borrower || {};
  // A refinance has an appraised value, not a purchase price.
  c.loan_property = !!(loan.loan_amount && (loan.purchase_price || loan.appraised_value) && loan.property_address?.street);
  c.borrower_info = !!(b.first_name && b.last_name && (b.ssn || b.dob));
  c.financial_info = !!(loan.urla?.current_employment?.length || loan.urla?.assets?.length);
  c.products_pricing = !!loan.note_rate;
  c.pre_approval = ['pre_approved', 'conditional_approval', 'clear_to_close', 'closing_scheduled', 'funded'].includes(loan.status);
  c.review_fees = hasFees(loan.le_fees);
  return c;
}
